import styled, { createGlobalStyle } from "styled-components";

export const MenuButton = styled('button')`
  font-weight: normal!important; 
  line-height: 26px!important; 
  color: #2d3436!important;
  width: 100%;
  text-align: left;
  display: flex!important;
  align-items: center!important;
  justify-content: flex-start!important;
  padding: 4px 8px!important;
  border: none;
  background: transparent;
  cursor: pointer;

  &:hover {
    background-color: #6C5CE7;
    color: white!important;
    border-radius: 4px;
  }

  &:disabled {
    background-color: transparent!important;
    color: #a9a9a9!important;
    cursor: not-allowed;
  }
`;


export const Empty = styled("div")`
  width: calc(100% / 2);
  height: 22px;
  margin: 4px 0px;
  border-radius: 4px;
  background-color: #f5f5f5;
`;

export const TableContainer = styled("div")`
  width: 100%;
  overflow-y: visible;    /* <-- permito overflow vertical */
  overflow-x: auto;    /* <- habilita scroll horizontal */
  border-radius: 8px;
  border: 1px solid #e0e4ea;
  background: white;

  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const Table = styled("table")`
  width: 100%;
  min-width: 1250px;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
`;

export const TH = styled("th")`
  padding: 12px 10px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.2;
  background-color: #fafafa;
  border-bottom: 1px solid #e0e4ea;
  white-space: nowrap;
  position: relative;

  &.sticky-left {
    position: sticky;
    left: 0;
    z-index: 99;              
    background-color: #fafafa;   /* fondo opaco */
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);
  }

  &.sticky-right {
    position: sticky;
    right: 0;
    z-index: 99;
    background-color: #fafafa;
    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.05);
  }

  &.center {
    text-align: center;
  }
`;

export const TD = styled("td")`
  padding: 10px;
  border-bottom: 1px solid #e0e4ea;
  vertical-align: middle;
  text-align: left;
  overflow: visible;        /* permitir que el contenido desborde */
  word-wrap: break-word;

  &.sticky-left {
    position: sticky;
    left: 0;
    z-index: 98;            /* un paso por debajo del TH */
    background-color: white; /* fondo opaco */
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);
  }

  &.sticky-right {
    position: sticky;
    right: 0;
    z-index: 98;
    background-color: white;
    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.05);
  }

  &.center {
    text-align: center;
  }
`;

export const TR = styled("tr")`
  background-color: white;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #f8f9fa;
    
    ${TD} {
      &.sticky-left,
      &.sticky-right {
        background-color: #f8f9fa;
      }
    }
  }
  
  &:last-child {
    ${TD} {
      border-bottom: none;
    }
  }
`;

export const TableHead = styled("thead")``;

export const TableBody = styled("tbody")``;

export const EmptyState = styled("div")`
    padding: 60px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
`;

export const TotalMembers = styled("div")`
  padding: 8px 16px;
  text-align: center;
  font-weight: 600;
  border: 2px solid #6b5ce7;
  color: #6b5ce7;
  font-size: 14px;
  border-radius: 24px;
  display: inline-block;
  line-height: 1.2;
  margin-bottom: 16px;
  background: white;
  transition: all 0.2s ease;
  
  &:hover {
    background: #6b5ce7;
    color: white;
  }
`;

export const IconLink = styled("a")`
  color: inherit;
  text-decoration: none;
  margin: 0 2px;
  padding: 4px;
  border: 0px;
  background: none;
  cursor: pointer;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(108, 92, 231, 0.1);
  }
  
  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const EmailWrapper = styled("div")`
  display: block;
  width: 100%;
  max-width: 240px;
  cursor: pointer;
  padding: 1px 2px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  overflow: hidden;
  
  /* Ensure normal text flow */
  direction: ltr;
  text-align: left;
  word-break: normal;
  overflow-wrap: normal;
  
  &:hover {
    background-color: rgba(108, 92, 231, 0.08);
  }
`;

export const EmailText = styled("span")`
  font-size: 13px;
  color: #2d3436;
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
  direction: ltr;
  
  /* Prevent text from breaking out of container */
  word-break: normal;
  overflow-wrap: normal;
  max-width: 100%;
  
  /* Ensure proper truncation */
  text-align: left;
`;

export const ContactActions = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const NameCell = styled("div")`
  font-weight: 500;
  
  .name {
    font-size: 14px;
    font-weight: 600;
    color: #2d3436;
  }
  
  .last-name {
    font-size: 13px;
    color: #666;
    font-weight: normal;
    margin-top: 2px;
  }
`;

export const PlanCell = styled("div")`
  .plan-name {
    font-size: 13px;
    font-weight: 500;
    color: #2d3436;
  }
  
  .plan-details {
    font-size: 11px;
    color: #666;
    margin-top: 2px;
  }
`;

export const TotalCell = styled("div")`
  .amount {
    font-size: 14px;
    font-weight: 600;
    color: #2d3436;
  }
  
  .currency {
    font-size: 11px;
    color: #666;
    margin-top: 2px;
  }
`;

export const ActionsWrapper = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DateText = styled("div")`
  font-size: 12px;
  color: #666;
`;

export const CountText = styled("div")`
  font-size: 13px;
  font-weight: 500;
  color: #2d3436;
`;

export const VerifiedText = styled("div")`
  font-size: 12px;
  color: #666;
`;

/* Tooltip wrapper for better positioning */
export const TooltipWrapper = styled("div")`
  position: relative;
  display: inline-block;
`;

/* Copy button that doesn't interfere with layout */
export const CopyButton = styled("button")`
  background: none;
  border: none;
  padding: 2px 4px;
  cursor: pointer;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(108, 92, 231, 0.1);
  }
`;

/* Global styles injection for email CopyToClipboard override */
export const EmailGlobalStyles = createGlobalStyle`
  .email-copy {
    width: 100% !important;
    height: auto !important;
    display: block !important;
    
    > div {
      display: block !important;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      text-align: left !important;
      width: 100% !important;
    }
  }
`;